import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_48we1z8tb5: FaireBrandEntity = {
  token: "b_48we1z8tb5",
  type: "brand",
  name: "Olive & Pique",
  avatarUrl:
    "https://cdn.faire.com/fastly/cb33a7b4f324f576cb8f4e43ffedb774a4c57cbba06c4baabdf61781f321f5ec.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dba86de4b493789490346a362b3a3c3262ab59fdb57cbde4c130145a33c387c8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cb33a7b4f324f576cb8f4e43ffedb774a4c57cbba06c4baabdf61781f321f5ec.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dba86de4b493789490346a362b3a3c3262ab59fdb57cbde4c130145a33c387c8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 101,
  isTopShop: true,
  isInsider: true,
  description:
    'Established in 2000 in Nu\'uanu, O\'ahu, Olive & Pique began as a creative pursuit and has transformed into a highly respected headwear label that celebrates women\'s ownership and inspiration. The name "Olive" symbolizes celestial love, while "Pique" denotes excitement; embracing both enhances each day. Our hats are designed to complement this spirit and elevate your well-being.\n\n— Join us in the journey of finding the hat for your soul.',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:46.404Z",
    importedBy: "entity-db-cli",
  },
};
